function tabs(ele, parent) {
  $(ele).on("click", function(e) {
    e.preventDefault();
    const $this = $(this);
    const thisTarget = $this.attr("href").replace(/^#/g, ".");
    $this.parent().addClass("active").siblings().removeClass("active");
    $(parent).find(thisTarget).addClass("active").siblings().removeClass("active");
  });
}

module.exports = {
  tabs
};



// WEBPACK FOOTER //
// ../assets/js/tabs.js